import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class SyncEntityClassificationService {

  constructor(private http: HttpClient) {}

  /**
   * Saves entity classification data. Action code: 78oi2o for saveEntities/reviewEntities, hh1pt8 for sync/acceptSave.
   */
  saveEntityClassification(
    baseUrl: string,
    clobSettings: { sso_id: string; entry_path?: string; screen_key?: string; save_type: string },
    details: any[],
    globalService: any,
    filterParams: any,
    checkLockedObjs: any[] = []
  ): Observable<{ errorMessage?: string }> {
    const saveType = clobSettings?.save_type || '';
    const actionCode = (saveType === 'saveEntities' || saveType === 'reviewEntities') ? '78oi2o' : 'hh1pt8';
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;

    const g = globalService ?? {};
    const f = filterParams ?? {};
    let params: any = _.merge({}, g, f);
    params.save_type = saveType;
    params.clob_data = JSON.stringify(details || []);
    params.clob_settings = JSON.stringify(clobSettings || {});
    params.process_name = 'entity-classification-grid-save';
    // Legacy posted no checkLockedbj at all, so send it only when the caller
    // resolved real lock descriptors from the selected rows.
    if (checkLockedObjs && checkLockedObjs.length > 0) {
      params.checkLockedbj = JSON.stringify(checkLockedObjs);
    } else {
      delete params.checkLockedbj;
    }
    params.scenarioCode = f.scenarioCode ?? f.scenario_code ?? g.scenarioCode ?? g.scenario_code ?? 'RAF';
    params.is_issue_key_enabled = f.is_issue_key_enabled ?? g.is_issue_key_enabled ?? 'N';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<{ errorMessage?: string }>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
